import {
	AfterViewInit,
	Component,
	Inject,
	OnInit,
	Optional,
	ChangeDetectionStrategy,
} from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
	MatDialogClose,
} from '@angular/material/dialog';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf, CurrencyPipe, DatePipe } from '@angular/common';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-loan-calculator-script',
	templateUrl: './loan-calculator-script.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: [
		`
			.mat-dialog-container {
				overflow: hidden;
			}
			h2 {
				display: flex;
				background-color: #f7f7f7;
				position: sticky;
				top: 0;
				z-index: 10;
				border-bottom: 1px solid #ddd;
				margin-bottom: 1.5em;
				flex-shrink: 0;
				cursor: move;
				padding-top: 0.75em;
			}
			.simple-card mat-card-content p,
			mat-card.simple-card mat-card-content p {
				font-size: 1rem;
			}
			.transform-sentence {
				text-transform: lowercase;
				font-style: italic;
				text-align: justify;
			}
			.transform-sentence::first-letter {
				text-transform: uppercase;
			}
			.modal-footer {
				display: flex;
				position: sticky;
				bottom: 0;
				background-color: #f7f7f7;
				border-top: 1px solid #ddd;
				flex-shrink: 0;
				margin-top: 0.75em;
			}
		`,
	],
	imports: [
		MatDialogTitle,
		CdkDrag,
		CdkDragHandle,
		CdkScrollable,
		MatDialogContent,
		NgIf,
		MatCard,
		MatCardContent,
		MatDialogActions,
		MatButton,
		MatDialogClose,
		CurrencyPipe,
		DatePipe,
	],
})
export class LoanCalculatorScriptComponent implements AfterViewInit {
	totalLegalFee: number;
	totalBalance: number;
	newLoanAmount: number;
	appName: string;
	termType: string;
	payment: number;
	lpp: number;
	startDate: string;
	isLpp: boolean = false;
	lppType: string;
	isSaha: boolean;
	constructor(
		public dialogRef: MatDialogRef<LoanCalculatorScriptComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any
	) {}
	ngAfterViewInit(): void {
		this.isSaha = this.data?.isSaha;
		this.isLpp = this.data?.loanInput?.Insurance === 'Yes' ? true : false;
		this.appName = this.data?.appName;
		this.termType = this.data?.loanInput?.Term_Type;
		this.payment = this.data?.payments?.payment;
		this.lpp = this.data?.payments?.lpp;
		this.startDate = this.data?.loanInput?.Start_Date;
		this.lppType = this.data?.payments?.isEnhanced;
		if (this.isSaha) {
			this.totalLegalFee = parseFloat(
				this.data?.loanDebts
					.map((b) => b.Legal_Fee)
					?.reduce((x, y) => x + y, 0)
					.toFixed(2)
			);
			this.totalBalance = parseFloat(
				this.data?.loanDebts
					.map((b) => b.dsLoanAmount)
					?.reduce((x, y) => x + y, 0)
					.toFixed(2)
			);
			this.newLoanAmount = parseFloat(
				(this.totalBalance + this.totalLegalFee).toFixed(2)
			);
		} else {
			this.newLoanAmount = this.data?.loanInput?.Loan_Amount;
		}
	}

	confirm() {
		this.dialogRef.close('confirmed');
	}
}
